var m = require('mithril');
var prop = require('mithril/stream');
var auth = require('../../auth/models/session');
var loaders = require('./loaders');
var alarmMonitor = require('./alarmMonitor');
var usersOnlineMonitor = require('./usersOnlineMonitor');
var auditMonitor = require('./auditMonitor');

var header = {};

header.oninit = function (vnode) {
  var ctrl = this;
  var requests = [];
  if (alarmMonitor.summaryRequestCount === 0) {
    requests.push(alarmMonitor.getSummary().catch(function (err) {
      console.error('Failed to load alarm summary', err);
    }));
  }
  if (usersOnlineMonitor.activeRequestCount === 0) {
    requests.push(usersOnlineMonitor.getUsers().catch(function (err) {
      console.error('Failed to load users online', err);
    }));
  }
  if (auditMonitor.requestCount === 0) {
    requests.push(auditMonitor.getCount().catch(function (err) {
      console.error('Failed to load audit resource count', err);
    }));
  }
  if (requests.length) {
    return Promise.all(requests);
  }
}

header.vm = {};

header.vm.activeTab = prop('Dashboards');

header.vm.logout = function () {
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/logout',
    method: 'GET'
  })
  .then(function () {
    window.location.replace('/');
  })
};

function isSuperuser() {
  return auth.user().isSuperuser == 1;
}

function isCalibrationUser() {
  return auth.user().isSuperuser == 1 || auth.user().isCalibrationSuperuser == 1;
}

function getUsersOnlineCount() {
  return usersOnlineMonitor.count;
}

function getActiveAlarmCount() {
  return alarmMonitor.activeAlarmCount;
}

function renderAggregateIcon() {
  return m('i.f-subheadline.f2-ns.flex.items-end.mono', [
    m('div', { style: { 'font-size': '1.2rem' } }, 'f')
  ]);
}

function navItem(options) {
  return Object.assign({
    visible: true,
    badge: null,
    badgeClass: '',
    external: false
  }, options);
}

function buildNavSections(vm) {
  return [
    [
      navItem({
        title: 'Home',
        activeTab: 'Dashboards',
        href: auth.user().homeLocation ? '/location/' + auth.user().homeLocation : auth.user().homeDashboard ? '/dashboard/' + auth.user().homeDashboard : '/',
        iconClass: 'ion-ios-home'
      }),
      navItem({
        title: 'Online Users',
        activeTab: 'Users Online',
        href: '/users/online',
        iconClass: 'ion-ios-people',
        badge: getUsersOnlineCount(),
        badgeClass: getUsersOnlineCount() > 0 ? 'green' : ''
      })
    ],
    [
      navItem({
        title: 'My Alarms',
        activeTab: 'Alarms',
        href: '/alarms',
        iconClass: 'ion-ios-bell',
        badge: getActiveAlarmCount(),
        badgeClass: getActiveAlarmCount() > 0 ? 'red' : ''
      }),
      navItem({
        title: 'Alarm Profiles',
        activeTab: 'Alarm Profiles',
        href: '/alarmprofile',
        iconClass: 'ion-ios-bell-outline',
        visible: isSuperuser()
      })
    ],
    [
      navItem({
        title: 'Reports',
        activeTab: 'Reports',
        href: '/reports',
        iconClass: 'ion-document-text'
      }),
      navItem({
        title: 'Aggregates',
        activeTab: 'Aggregates',
        href: '/aggregates',
        icon: renderAggregateIcon(),
        visible: isSuperuser()
      })
    ],
    [
      navItem({
        title: 'Ontology',
        activeTab: 'Ontology',
        href: '/ontology',
        iconClass: 'ion-pricetags',
        visible: isSuperuser()
      }),
      navItem({
        title: 'Locations',
        activeTab: 'Locations',
        href: '/location',
        iconClass: 'ion-map'
      })
    ],
    [
      navItem({
        title: 'Audit',
        activeTab: 'Audit',
        href: '/audit',
        iconClass: 'ion-alert-circled',
        badge: auditMonitor.count,
        badgeClass: auditMonitor.count > 0 ? 'yellow' : '',
        visible: isSuperuser()
      }),
      navItem({
        title: 'Hosts',
        activeTab: 'Networks',
        href: '/networks',
        iconClass: 'ion-network',
        visible: isSuperuser()
      }),
      navItem({
        title: 'BACnet/SC Hubs',
        activeTab: 'BacnetConnections',
        href: '/bacnet-connections',
        iconClass: 'ion-locked',
        visible: isSuperuser()
      }),
      navItem({
        title: 'Agent',
        activeTab: 'Agents',
        href: '/agent',
        iconClass: 'ion-speedometer',
        visible: isSuperuser()
      })
    ],
    [
      navItem({
        title: 'Certified Instruments',
        activeTab: 'CertifiedInstruments',
        href: '/certifiedinstruments',
        iconClass: 'ion-pinpoint',
        visible: isCalibrationUser()
      }),
      navItem({
        title: 'Sensors',
        activeTab: 'Calibrations',
        href: '/calibrations',
        iconClass: 'ion-android-locate',
        visible: isCalibrationUser()
      })
    ],
    [
      navItem({
        title: 'Users',
        activeTab: 'Users',
        href: '/users/',
        iconClass: 'ion-ios-person',
        visible: isSuperuser()
      }),
      navItem({
        title: 'Groups',
        activeTab: 'Groups',
        href: '/groups/',
        iconClass: 'ion-ios-people'
      })
    ],
    [
      navItem({
        title: 'Events',
        activeTab: 'Events',
        href: '/events',
        iconClass: 'ion-android-calendar',
        visible: isSuperuser()
      }),
      navItem({
        title: 'Settings',
        activeTab: 'Settings',
        href: '/settings',
        iconClass: 'ion-ios-gear',
        visible: isSuperuser()
      })
    ],
    [
      navItem({
        title: 'Docs',
        activeTab: 'Docs',
        href: '/docs/',
        iconClass: 'ion-ios-help-outline',
        external: true
      })
    ]
  ].map(function (section) {
    return section.filter(function (item) { return item.visible; });
  }).filter(function (section) {
    return section.length > 0;
  });
}

function renderCondensedNavItem(vm, item) {
  var active = vm.activeTab() === item.activeTab;
  var selectedTextClass = item.activeTab === 'Audit' || item.activeTab === 'Alarms' || item.activeTab === 'Users Online' ? 'black' : 'near-black';
  var colorClass = active ? selectedTextClass : (item.badgeClass || 'white');
  var link = item.external ? 'a' : m.route.Link;
  var attrs = {
    class: 'relative flex items-center justify-center pv2 w-100 ' + (active ? 'bg-blue ' + selectedTextClass : 'white'),
    href: item.href,
    title: item.title
  };

  if (item.external) {
    attrs.target = '_blank';
    attrs.rel = 'noopener noreferrer';
  }

  return m(link, attrs, [
    item.icon || m('i.f-subheadline.f2-ns', { class: item.iconClass + ' ' + colorClass }),
    item.badge ? m('span.absolute.br-100', {
      class: item.badgeClass,
      style: {
        top: '0.15rem',
        right: '0.3rem',
        width: '0.38rem',
        height: '0.38rem',
        backgroundColor: 'currentColor'
      }
    }) : null
  ]);
}

header.renderCondensedSidebar = function () {
  var vm = header.vm;
  var sections = buildNavSections(vm);

  return m('div.flex.flex-column.items-center.pt3.pb4', sections.map(function (section, sectionIndex) {
    return [
      sectionIndex > 0 ? m('div.w-60.mv2.bb.b--mid-gray') : null,
      section.map(function (item) {
        return renderCondensedNavItem(vm, item);
      })
    ];
  }));
};

header.view = function (vnode) {
  var vm = header.vm;

  return m('div.mw-100.bg-near-black.ph2.justify-between.relative.h-100', {style: {'margin-bottom': '350px'}}, [
    m('div.pb3.f-subheadline.mb3.bb.bw1.pt3.pr3', [
      m('div', [ 
        m('div.flex.justify-between', [
          m('div.flex',
          {
            onclick: function () {
              document.getElementById('user-dropdown').classList.remove('dn');
              
            },
          },
          [
            m('div.f3.truncate.mr2', auth.user().firstName),
            auth.user().expiredPassword && ((!auth.user().managedByAzure || auth.user().managedByAzure != '1') && (!auth.user().managedByCloud || auth.user().managedByCloud != '1')) ?
              m('i', {class: 'red ion-alert f1 mr2'})
            :
              '',
            m('div.ml1.f2.fw3.dn.db-m.db-l', {class: 'ion-ios-arrow-down'}),
          ]),
          m('div.flex.dn-l.f3.fw3.pr3', [
            m(m.route.Link, {
              class: 'white dim  h-100 flex items-center ',
              href: '/profile/' + (auth.user()['@rid']? auth.user()['@rid'].slice(1): '')
            },[
              m('i', {class: 'f2 mh2 ion-ios-person-outline'}),
              m('span', 'Profile'),
              auth.user().expiredPassword && ((!auth.user().managedByAzure || auth.user().managedByAzure != '1') && (!auth.user().managedByCloud || auth.user().managedByCloud != '1')) ?
                m('i', {class: 'red ion-alert f1 ml2'})
              :
                '',
            ]),
            m('a.white.dim.h-100.flex.items-center', {
              href: '/',
              onclick: function (e) {
                e.preventDefault(); 
                vm.logout();
              }
            }, [
              m('i', {class: 'mh2 ion-log-out'}),
              m('span', 'Logout')
            ])
          ]),
        ]),
        m('div.child.absolute.bg-near-black.br2.ba.pa2.dn', {
          id: 'user-dropdown',
          onmouseover: function () {
            document.getElementById('user-dropdown').classList.remove('dn');
            
          },
          onmouseout: function () {
            document.getElementById('user-dropdown').classList.add('dn');
          }
        }, [
          m(m.route.Link, {
            class: 'white dim f3 pa2 h-100 flex items-center ',
            href: '/profile/' + (auth.user()['@rid']? auth.user()['@rid'].slice(1): '')
          },[
            m('i', {class: 'f3 mr2 ion-ios-person-outline'}),
            m('span', 'Profile'),
            auth.user().expiredPassword && ((!auth.user().managedByAzure || auth.user().managedByAzure != '1') && (!auth.user().managedByCloud || auth.user().managedByCloud != '1')) ?
              m('i', {class: 'red ion-alert f1 ml2'})
            :
              '',
          ]),
          m('a.white.dim.f3.pa2.h-100.flex.items-center', {
            href: '/',
            onclick: function (e) {
              e.preventDefault();
              vm.logout();
            }
          }, [
            m('i', {class: 'f3 mr2 ion-log-out'}),
            m('span', 'Logout')
          ])
        ])
      ]),
      // m('span.f4.red', 'License expired (10/01/2021)')
    ]),
    m('div.flex.flex-column', [
      m(m.route.Link, {
        class: 'ph1 flex items-center pv1 ' + 
          (vm.activeTab() === 'Dashboards' ? ' near-black bg-blue ' : 'white'), 
        href: auth.user().homeLocation ? '/location/' + auth.user().homeLocation : auth.user().homeDashboard ? '/dashboard/' + auth.user().homeDashboard : '/'
      },[
        m('i.f-subheadline.f2-ns', {class: 'ion-ios-home'}),
        m('span.pl3.f4', 'Home')
      ]),
      m(m.route.Link, {
        class: 'ph1 flex items-center pv1 flex justify-between' + 
          (vm.activeTab() === 'Users Online' ? ' black bg-blue ' : ' white'),
        href: '/users/online'
      },[
        m('div',{class: vm.activeTab() === 'Users Online' ? 'black' : (getUsersOnlineCount() > 0 ? 'green':'')}, [
          m('i.f-subheadline.f2-ns', {class: 'ion-ios-people'}),
          m('span.pl3.f4', 'Online Users')
        ]),
        m('div.pr2', {class: vm.activeTab() === 'Users Online' ? 'black' : (getUsersOnlineCount() > 0 ? 'green':'')}, [
          getUsersOnlineCount()
        ])
      ]),
      m('div.mv2.pv2.bb', 'Alarms'),
      m(m.route.Link, {
        class: 'ph1 flex items-center pv1 flex justify-between' + 
          (vm.activeTab() === 'Alarms' ? ' black bg-blue ' : ' white'),
        href: '/alarms'
      },[
        m('div',{class: vm.activeTab() === 'Alarms' ? 'black' : (getActiveAlarmCount() > 0 ? 'red':'')}, [
          m('i.f-subheadline.f2-ns', {class: 'ion-ios-bell'}),
          m('span.pl3.f4', 'My Alarms')
        ]),
        m('div.pr2', {class: vm.activeTab() === 'Alarms' ? 'black' : (getActiveAlarmCount() > 0 ? 'red':'')}, [
          getActiveAlarmCount()
        ])
      ]),
      m(m.route.Link, {
        class: 'ph1 flex items-center pv1 ' + 
          (vm.activeTab() === 'Alarm Profiles' ? ' near-black bg-blue ' : 'white'), 
        href: '/alarmprofile',
        style: {
          display: ((auth.user().isSuperuser == 1) ? '' : 'none')
        }
      },[
        m('i.f-subheadline.f2-ns', {class: 'ion-ios-bell-outline'}),
        m('span.pl3.f4', 'Alarm Profiles')
      ]),
      m('div.mv2.pv2.bb', 'Data'),
      m(m.route.Link, {
        class: 'ph1 flex items-center pv1 ' + 
          (vm.activeTab() === 'Reports' ? ' near-black bg-blue ' : 'white'), 
        href: '/reports'
      },[
        m('i.f-subheadline.f2-ns', {class: 'ion-document-text'}),
        m('span.pl3.f4', 'Reports')
      ]),
      // Superuser
      m('div', [
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'Aggregates' ? ' near-black bg-blue ' : 'white'), 
          href: '/aggregates',
          style: {
            display: ((auth.user().isSuperuser == 1) ? '' : 'none')
          }
        },[
          //m('i.f-subheadline.f2-ns', {class: 'ion-ios-pie'}),
          m('i.f-subheadline.f2-ns.flex.items-end.mr1.mono', [
            m('div', {style:{'font-size': '1.2rem'}}, 'f'),
            // m('div', {style:{'font-size': '1.2rem'}}, 'x')
          ]),
          m('span.pl3.f4', 'Aggregates')
        ]),
        m('div.mv2.pv2.bb', {
            style: {
              display: ((auth.user().isSuperuser == 1) ? '' : 'none')
            },
          },
        'Modeling'),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'Ontology' ? ' near-black bg-blue ' : 'white'), 
          href: '/ontology',
          style: {
            display: ((auth.user().isSuperuser == 1) ? '' : 'none')
          }
        },[
          m('i.f-subheadline.f2-ns', {class: 'ion-pricetags'}),
          m('span.pl3.f4', 'Ontology')
        ]),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'Locations' ? ' near-black bg-blue ' : 'white'), 
          href: '/location',
        },[
          m('i.f-subheadline.f2-ns', {class: 'ion-map'}),
          m('span.pl3.f4', 'Locations')
        ]),
        m('div.mv2.pv2.bb', 
          { style: { display: ((auth.user().isSuperuser == 1) ? '' : 'none')}},
          'Network'),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 flex justify-between' + 
            (vm.activeTab() === 'Audit' ? ' black bg-blue ' : ' white'),
          href: '/audit',
          style: {
            display: ((auth.user().isSuperuser == 1) ? '' : 'none')
          }
        },[
          m('div',{class: vm.activeTab() === 'Audit' ? 'black' : (auditMonitor.count > 0 ? 'yellow':'')}, [
            m('i.f-subheadline.f2-ns', {class: 'ion-alert-circled'}),
            m('span.pl3.f4', 'Audit')
          ]),
          m('div.pr2', {class: vm.activeTab() === 'Audit' ? 'black' : (auditMonitor.count > 0 ? 'yellow':'')}, [
            auditMonitor.count
          ])
        ]),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'Networks' ? ' near-black bg-blue ' : 'white'), 
          href: '/networks',
          style: {
            display: ((auth.user().isSuperuser == 1) ? '' : 'none')
          }
        },[
          m('i.f-subheadline.f2-ns', {class: 'ion-network'}),
          m('span.pl3.f4', 'Hosts')
        ]),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' +
            (vm.activeTab() === 'BacnetConnections' ? ' near-black bg-blue ' : 'white'),
          href: '/bacnet-connections',
          style: {
            display: ((auth.user().isSuperuser == 1) ? '' : 'none')
          }
        },[
          m('i.f-subheadline.f2-ns', {class: 'ion-locked'}),
          m('span.pl3.f4', 'BACnet/SC Hubs')
        ]),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' +
            (vm.activeTab() === 'Agents' ? ' near-black bg-blue ' : 'white'),
          href: '/agent',
          style: {
            display: ((auth.user().isSuperuser == 1) ? '' : 'none')
          }
        },[
          m('i.f-subheadline.f2-ns', { class: 'ion-speedometer mr1' }),
          m('span.pl2.f4', 'Agent')
        ]),
        m('div.mv2.pv2.bb', {
          style: {
            display: isCalibrationUser() ? '' : 'none'
          }
        }, 'Calibrations'),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'CertifiedInstruments' ? ' near-black bg-blue ' : 'white'), 
          href: '/certifiedinstruments',
          style: {
            display: isCalibrationUser() ? '' : 'none'
          }
        },[
          m('i.f-subheadline.f2-ns', {class: 'ion-pinpoint'}),
          m('span.pl3.f4', 'Certified Instruments')
        ]),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'Calibrations' ? ' near-black bg-blue ' : 'white'), 
          href: '/calibrations',
          style: {
             display: isCalibrationUser() ? '' : 'none'
          }
        },[
          m('i.f-subheadline.f2-ns', {class: 'ion-android-locate'}),
          m('span.pl3.f4', 'Sensors')
        ]),
        m('div.mv2.pv2.bb',
          { style: { display: '' }},
          'Admin'),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'Users' ? ' near-black bg-blue ' : 'white'), 
          href:'/users/',
          style: {
            display: ((auth.user().isSuperuser == 1) ? '' : 'none')
          }
        }, [
          m('i.f-subheadline.f2-ns.pr1', {class: 'ion-ios-person'}),
          m('span.pl3.f4', 'Users')
        ]),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'Groups' ? ' near-black bg-blue ' : 'white'), 
          href:'/groups/',
          style: {
            display: ''
          }
        }, [
          m('i.f-subheadline.f2-ns', {class: 'ion-ios-people'}),
          m('span.pl3.f4', 'Groups')
        ]),
        m('div.mv2.pv2.bb', 
          { style: { display: ((auth.user().isSuperuser == 1) ? '' : 'none')}},
          'System'),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'Events' ? ' near-black bg-blue ' : 'white'), 
          href: '/events',
          style: {
            display: ((auth.user().isSuperuser == 1) ? '' : 'none')
          }
        },[
          m('i.f-subheadline.f2-ns', {class: 'ion-android-calendar'}),
          m('span.pl3.f4', 'Events')
        ]),
        m(m.route.Link, {
          class: 'ph1 flex items-center pv1 ' + 
            (vm.activeTab() === 'Settings' ? ' near-black bg-blue ' : 'white'), 
          href: '/settings',
          style: {
            display: ((auth.user().isSuperuser == 1) ? '' : 'none')
          }
        },[
          m('i.f-subheadline.f2-ns', {class: 'ion-ios-gear'}),
          m('span.pl3.f4', 'Settings')
        ]),
        m('div.mv2.pv2.bb', 'Help'),
        m('a', {
          class: 'ph1 flex items-center pv1 white',
          href: '/docs/',
          target: '_blank',
          rel: 'noopener noreferrer'
        }, [
          m('i.f-subheadline.f2-ns', {class: 'ion-ios-help-outline'}),
          m('span.pl3.f4', 'Docs')
        ]),
      ]),
      m('div', {
        style: {
          height: '4em'
        }
      }) // Spacer
    ])
  ])
  
}

module.exports = header;
